export default "__VITE_ASSET__98217612__"